export declare type HtmlInterfaceName =
	"HTMLElement"|
	"HTMLAnchorElement"|
	"HTMLAppletElement"|
	"HTMLAreaElement"|
	"HTMLAudioElement"|
	"HTMLBaseElement"|
	"HTMLBaseFontElement"|
	"HTMLQuoteElement"|
	"HTMLBodyElement"|
	"HTMLBRElement"|
	"HTMLButtonElement"|
	"HTMLCanvasElement"|
	"HTMLTableCaptionElement"|
	"HTMLTableColElement"|
	"HTMLDataElement"|
	"HTMLDataListElement"|
	"HTMLModElement"|
	"HTMLDirectoryElement"|
	"HTMLDivElement"|
	"HTMLDListElement"|
	"HTMLEmbedElement"|
	"HTMLFieldSetElement"|
	"HTMLFontElement"|
	"HTMLFormElement"|
	"HTMLFrameElement"|
	"HTMLFrameSetElement"|
	"HTMLHeadingElement"|
	"HTMLHeadElement"|
	"HTMLHRElement"|
	"HTMLHtmlElement"|
	"HTMLIFrameElement"|
	"HTMLImageElement"|
	"HTMLInputElement"|
	"HTMLUnknownElement"|
	"HTMLLabelElement"|
	"HTMLLegendElement"|
	"HTMLLIElement"|
	"HTMLLinkElement"|
	"HTMLPreElement"|
	"HTMLMapElement"|
	"HTMLMarqueeElement"|
	"HTMLMenuElement"|
	"HTMLMetaElement"|
	"HTMLMeterElement"|
	"HTMLObjectElement"|
	"HTMLOListElement"|
	"HTMLOptGroupElement"|
	"HTMLOptionElement"|
	"HTMLOutputElement"|
	"HTMLParagraphElement"|
	"HTMLParamElement"|
	"HTMLPictureElement"|
	"HTMLProgressElement"|
	"HTMLScriptElement"|
	"HTMLSelectElement"|
	"HTMLSourceElement"|
	"HTMLSpanElement"|
	"HTMLStyleElement"|
	"HTMLTableElement"|
	"HTMLTableSectionElement"|
	"HTMLTableDataCellElement"|
	"HTMLTemplateElement"|
	"HTMLTextAreaElement"|
	"HTMLTableHeaderCellElement"|
	"HTMLTimeElement"|
	"HTMLTitleElement"|
	"HTMLTableRowElement"|
	"HTMLTrackElement"|
	"HTMLUListElement"|
	"HTMLVideoElement"|
	"MSHTMLWebViewElement";

/**
 * An array of all known HTMLInterface names
 * @type {HtmlInterfaceName[]}
 */
const htmlInterfaceNames: HtmlInterfaceName[] = [
	"HTMLElement",
	"HTMLAnchorElement",
	"HTMLAppletElement",
	"HTMLAreaElement",
	"HTMLAudioElement",
	"HTMLBaseElement",
	"HTMLBaseFontElement",
	"HTMLQuoteElement",
	"HTMLBodyElement",
	"HTMLBRElement",
	"HTMLButtonElement",
	"HTMLCanvasElement",
	"HTMLTableCaptionElement",
	"HTMLTableColElement",
	"HTMLDataElement",
	"HTMLDataListElement",
	"HTMLModElement",
	"HTMLDirectoryElement",
	"HTMLDivElement",
	"HTMLDListElement",
	"HTMLEmbedElement",
	"HTMLFieldSetElement",
	"HTMLFontElement",
	"HTMLFormElement",
	"HTMLFrameElement",
	"HTMLFrameSetElement",
	"HTMLHeadingElement",
	"HTMLHeadElement",
	"HTMLHRElement",
	"HTMLHtmlElement",
	"HTMLIFrameElement",
	"HTMLImageElement",
	"HTMLInputElement",
	"HTMLModElement",
	"HTMLUnknownElement",
	"HTMLLabelElement",
	"HTMLLegendElement",
	"HTMLLIElement",
	"HTMLLinkElement",
	"HTMLPreElement",
	"HTMLMapElement",
	"HTMLMarqueeElement",
	"HTMLMenuElement",
	"HTMLMetaElement",
	"HTMLMeterElement",
	"HTMLUnknownElement",
	"HTMLObjectElement",
	"HTMLOListElement",
	"HTMLOptGroupElement",
	"HTMLOptionElement",
	"HTMLOutputElement",
	"HTMLParagraphElement",
	"HTMLParamElement",
	"HTMLPictureElement",
	"HTMLPreElement",
	"HTMLProgressElement",
	"HTMLQuoteElement",
	"HTMLScriptElement",
	"HTMLSelectElement",
	"HTMLSourceElement",
	"HTMLSpanElement",
	"HTMLStyleElement",
	"HTMLTableElement",
	"HTMLTableSectionElement",
	"HTMLTableDataCellElement",
	"HTMLTemplateElement",
	"HTMLTextAreaElement",
	"HTMLTableSectionElement",
	"HTMLTableHeaderCellElement",
	"HTMLTableSectionElement",
	"HTMLTimeElement",
	"HTMLTitleElement",
	"HTMLTableRowElement",
	"HTMLTrackElement",
	"HTMLUListElement",
	"HTMLVideoElement",
	"MSHTMLWebViewElement",
	"HTMLPreElement"
];

/**
 * The Set of all known HTMLInterface names
 * @type {Set<HtmlInterfaceName>}
 */
export const HTML_INTERFACE_NAMES = new Set<HtmlInterfaceName>(htmlInterfaceNames);